import { render, staticRenderFns } from "./ClassSelection.vue?vue&type=template&id=335cc487&scoped=true&"
import script from "./ClassSelection.vue?vue&type=script&lang=ts&"
export * from "./ClassSelection.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSelection.vue?vue&type=style&index=0&id=335cc487&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335cc487",
  null
  
)

export default component.exports